export default __webpack_public_path__ + "static/drowsy-2c0656d07ccc1102e078bbd8fd42ccb4.mp4";